import { render } from "./DomainInstructions.vue?vue&type=template&id=306e1c01"
import script from "./DomainInstructions.vue?vue&type=script&lang=js"
export * from "./DomainInstructions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__